// extracted by mini-css-extract-plugin
export default {"wrapper":"UserChats_wrapper__YPADf","userChats":"UserChats_userChats__NQMEb","chatOverview":"UserChats_chatOverview__-dSwj"};